import { render, staticRenderFns } from "./AdminRaise.vue?vue&type=template&id=653d484c&scoped=true&"
import script from "./AdminRaise.vue?vue&type=script&lang=js&"
export * from "./AdminRaise.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "653d484c",
  null
  
)

export default component.exports